import { render, staticRenderFns } from "./MedOcuLaboral.vue?vue&type=template&id=5d5c399c&scoped=true"
import script from "./MedOcuLaboral.vue?vue&type=script&lang=js"
export * from "./MedOcuLaboral.vue?vue&type=script&lang=js"
import style0 from "./MedOcuLaboral.vue?vue&type=style&index=0&id=5d5c399c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5c399c",
  null
  
)

export default component.exports